// Reusing the resource detail page
import ResourceDetailPage from "~/pages/resource/[slug]";

export default ResourceDetailPage;
